import React from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "../../UI/IconButton/IconButton";
import { useSelector } from "react-redux";

import { ReactComponent as menuUser } from "../../../assets/images/icon-user.svg";
import { ReactComponent as menuBookmark } from "../../../assets/images/icon-file.svg";
import { ReactComponent as menuSignout } from "../../../assets/images/icon-sign-out.svg";
import { ReactComponent as menuSettings } from "../../../assets/images/icon-settings.svg";

import "./GreetingAndMenu.scss";

const GreetingAndMenu = ({
  handleExit = () => {},
  isPlaying = false,
  tutorialFooterActive = false,
  tutorialFooterStep = -1,
}) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.createUser);

  return (
    <div className={`greeting-menu `}>
      <div className="text">
        Hello, <span className="user">{user?.systemName}</span>!
      </div>
      <div className="icons-wrapper">
        <IconButton
          edge="end"
          color="inherit"
          className="icon"
          aria-label="Profile and achievements"
          onClick={() => navigate("/missionAccomplishments")}
          imageSrc={menuUser}
          // isActive={tutorialFooterStep === 0}
          disabled={tutorialFooterActive}
          title={"Profile"}
        />

        <IconButton
          edge="end"
          color="inherit"
          className="icon"
          aria-label="Settings"
          onClick={() => navigate("/settings")}
          imageSrc={menuSettings}
          isActive={tutorialFooterStep === 0}
          disabled={tutorialFooterActive}
          title="Settings"
        />

        {!isPlaying && (
          <IconButton
            edge="end"
            color="inherit"
            className="icon"
            aria-label="Clue board"
            imageSrc={menuBookmark}
            onClick={() => navigate("/clueboard")}
            isActive={tutorialFooterStep === 1}
            disabled={tutorialFooterActive}
            title={"Clue Board"}
          />
        )}

        <IconButton
          edge="end"
          color="inherit"
          className="icon"
          aria-label="Sign out"
          onClick={() => handleExit()}
          imageSrc={menuSignout}
          isActive={tutorialFooterStep === 2}
          disabled={tutorialFooterActive}
          title={"Signout"}
        />
      </div>
    </div>
  );
};

export default GreetingAndMenu;
